<template>
    <date-picker
        calendar-class="calendar"
        wrapper-class="datepicker"
        input-class="input"
        :class="{ open }"
        :placeholder="placeholder"
        :clear-button="true"
        :calendar-button="true"
        :monday-first="true"
        :disabled="disabled"
        @input="inputUpdate($event)"
        @opened="opened"
        @closed="closed"
        :value="val"
        :name="inputId"
        :id="inputId"
    ></date-picker>
</template>

<script>
    import DatePicker from 'vuejs-datepicker';

    export default {
        components: {
            DatePicker,
        },
        props: {
            placeholder: {},
            disabled: {
                type: Object,
                default: () => {},
            },
            val: {},
            inputId: {},
        },
        data() {
            return {
                open: false,
            };
        },
        methods: {
            opened() {
                this.open = true;
            },
            closed() {
                this.open = false;
            },
            inputUpdate(date) {
                let value = null;
                if (date) {
                    const month = date.getMonth() + 1;
                    const padMonth = month.toString().padStart(2, '0');
                    const padDate = date.getDate().toString().padStart(2, '0');

                    value = `${date.getFullYear()}-${padMonth}-${padDate}`;
                }

                this.$emit('input', value);
            },
        },
    };
</script>

<style lang="scss">
    @import '../../assets/scss/partials/variables';
    @import '../../assets/scss/partials/mixins';

    .vdp-datepicker.datepicker {
        position: static;
        background-color: white;

        text-align: center;

        border-style: solid;
        border-width: 1px;
        border-color: transparent;

        @media screen and (min-width: $tablet) {
            text-align: left;
        }

        &.open {
            border-color: $kpmg-blue;
        }

        > div:first-child {
            position: relative;
            height: 100%;
            padding-right: 10px;
            cursor: pointer;
        }

        .input {
            width: calc(100% - 30px);
            height: 100%;
            padding: 8px 0;
            border: 0;
            font-size: 12px;
            letter-spacing: 0.6px;
            text-align: center;
            color: $greyish-brown;
            vertical-align: middle;
            cursor: pointer;

            @media screen and (min-width: $tablet) {
                width: 134px;
                padding: 8px 0 8px 35px;
                text-align: left;
            }
        }
    }

    .vdp-datepicker {
        &__calendar-button {
            display: none;
            position: absolute;
            top: 10px;
            left: 10px;

            @media screen and (min-width: $tablet) {
                display: inline;
            }

            i {
                display: inline-block;
                width: 15px;
                height: 15px;

                background-image: url('../../assets/images/icons/icon-calendar.svg');
                span {
                    display: none;
                }
            }
        }

        &__clear-button {
            i {
                display: inline-block;
                width: 12px;
                height: 12px;

                vertical-align: middle;

                background-size: 100%;
                background-image: url('../../assets/images/icons/icon-close-grey.svg');
                span {
                    display: none;
                }
            }
        }

        & &__calendar {
            width: 0;

            top: calc(100% + 5px);
            left: 0;

            @include fontArial();
            font-size: 14px;

            transition: width 1s ease;
        }

        &.open &__calendar {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/filters/DateInput.vue